import React from 'react'
import withIcon from '@/components/withIcon'

type TProps = {
  className: string
}

function IconPricing({ className }: TProps) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2H1c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Zm-3.9 10H4.9C4.5 10.6 3.4 9.5 2 9.1V6.9C3.4 6.5 4.5 5.4 4.9 4h6.3c.4 1.4 1.5 2.5 2.9 2.9v2.3c-1.5.3-2.6 1.4-3 2.8Z"
        fill="currentColor"
      />
      <path
        d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default withIcon(IconPricing)
